import { useQueryCashed } from "@/hooks/useQueryCashed";

import { AutoLoginApi } from "../api";

export const useRepeatedAutoLogin = (enabled: boolean) => {
  return useQueryCashed({
    queryKey: ["REPEATED_AUTO_LOGIN"],
    queryFn: async () => {
      return AutoLoginApi.send();
    },
    refetchInterval: 1000 * 60,
    enabled,
  });
};
